export default {
  get: {},
  post: {
    getUserInfo: "/system/init",
    logout: "/member/logout"
  }
};
